export interface Toast {
  id: number
  message: string
  action?: { label: string; run: () => void }
  tone: 'info' | 'error'
}

let nextId = 1

class Toasts {
  current = $state<Toast | null>(null)
  private timer: ReturnType<typeof setTimeout> | null = null

  /** One at a time: a second toast replaces the first rather than stacking. */
  show(
    message: string,
    options: { action?: Toast['action']; tone?: Toast['tone']; durationMs?: number } = {},
  ): void {
    if (this.timer) clearTimeout(this.timer)
    const toast: Toast = {
      id: nextId++,
      message,
      action: options.action,
      tone: options.tone ?? 'info',
    }
    this.current = toast
    this.timer = setTimeout(() => this.dismiss(toast.id), options.durationMs ?? 6000)
  }

  error(message: string): void {
    this.show(message, { tone: 'error' })
  }

  dismiss(id?: number): void {
    if (id !== undefined && this.current?.id !== id) return
    if (this.timer) clearTimeout(this.timer)
    this.timer = null
    this.current = null
  }

  runAction(): void {
    const action = this.current?.action
    this.dismiss()
    action?.run()
  }
}

export const toasts = new Toasts()
